import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type PendingWorkOrderSignoffForUser = {
   signoffid: number;
   stepid: number;
   entryid: number;
   date: number;
   status: 'pending';
   type: 'team';
   displayDate: string;
   workorderid: string;
   guideTitle: string;
   guideURL: string;
   isUsingSSO: boolean;
   ssoApprovalUrl: string;
   ssoRejectUrl: string;
   userAvatar: string;
   userProfile: string;
   userid: number;
   username: string;
};

export type GetPendingWorkOrderSignoffsForUserResponse = {
   pendingSignoffs: PendingWorkOrderSignoffForUser[];
};

export async function getPendingWorkOrderSignoffsForUser(
   userid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetPendingWorkOrderSignoffsForUserResponse> {
   return makeRequest('get', `/signoffs/pending/${userid}`, {
      ...common,
   });
}
